// extracted by mini-css-extract-plugin
module.exports = {"box":"com-page-area_box_3C-yh","form":"com-page-area_form_3sTCp","preview":"com-page-area_preview_201Ub","zone":"com-page-area_zone_T2vOD"};